module.exports = __webpack_public_path__ + "26785d51b8d53111abe6371ead732599.pdf";